import { EFFECTIVENESS_REPORT_TABS } from '../../../components/constants/effectivenessReportTabs'

export const ReportTabs = Object.fromEntries(
  EFFECTIVENESS_REPORT_TABS.map((tab, index) => [tab.value, index + 1])
)

export const ReportTabLabels = Object.fromEntries(
  EFFECTIVENESS_REPORT_TABS.map((tab, index) => [index + 1, tab.label])
)

export const ReportTabsMap = { ...ReportTabs }

export const TAB_CONFIG = EFFECTIVENESS_REPORT_TABS.map(({ value, label }) => ({
  label,
  key: value
}))

export const TAB_ENDPOINTS = Object.fromEntries(
  EFFECTIVENESS_REPORT_TABS.map((tab) => [tab.value, tab.endpoint])
)
